/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleStateTransitionFromState } from './moduleStateTransitionFromState';
import type { ModuleVersionState } from './moduleVersionState';
import type { ModuleStateTransitionComment } from './moduleStateTransitionComment';
import type { ModuleStateTransitionMetadata } from './moduleStateTransitionMetadata';

/**
 * Represents a single state transition of a module
 */
export interface ModuleStateTransition {
  fromState?: ModuleStateTransitionFromState;
  toState: ModuleVersionState;
  changedAt: string;
  changedBy: string;
  comment?: ModuleStateTransitionComment;
  metadata?: ModuleStateTransitionMetadata;
}
